import React from 'react'
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  IconButton,
  Button,
  Hidden,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import ShareIcon from '@material-ui/icons/Share'
import { Link } from 'react-router-dom'
import './styles.css'

const useStyles = makeStyles((theme) => ({
  //estas son las reglas de css del componente
  menuButton: {
    marginRight: theme.spacing(2),
    // [theme.breakpoints.up("sm")]: {
    //   display: "none",
    // },
  },
  title: {
    flexGrow: 1,
    fontWeight: 300,
  },
  appBar: {
    // [theme.breakpoints.up("sm")]: {
    //   width: `calc(100% - ${240}px)`,
    //   marginLeft: 240,
    // },
  },
  button: {
    textTransform: 'none',
    fontSize: 18,
    fontWeight: 300,
    fontWeightLight: 100,
    // fontFamily: "Roboto",
  },
}))

const Navbar = ({ accionAbrir, formState }) => {
  const classes = useStyles()
  return (
    <AppBar className={classes.appBar} position="fixed" color="primary">
      <Toolbar>
        <Hidden mdUp>
          <IconButton
            color="inherit"
            aria-label="menu"
            className={classes.menuButton}
            onClick={() => accionAbrir()}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>

        <Typography variant="h6" className={classes.title}>
          TestCOVID
        </Typography>

        <Hidden smDown>
          <Link to="/" className="navbarLinks">
            <Button variant="text" color="inherit" className={classes.button}>
              Inicio
            </Button>
          </Link>
          <Link to="/test" className="navbarLinks">
            <Button variant="text" color="inherit" className={classes.button}>
              Test
            </Button>
          </Link>

          {formState.name !== '' || formState.age !== 0 ? (
            formState.radioAFiebre == 'end' &&
            formState.radioBTos == 'end' &&
            formState.radioCGarganta == 'end' &&
            formState.radioDDiarrea == 'end' &&
            formState.radioEOlfato == 'end' &&
            formState.radioFErupciones == 'end' &&
            formState.radioGColor == 'end' &&
            formState.radioHRespirar == 'end' ? (
              <Link to="/resultadosTres" className="navbarLinks">
                <Button
                  variant="text"
                  color="inherit"
                  className={classes.button}
                >
                  Resultados
                </Button>
              </Link>
            ) : formState.radioHRespirar == 'start' ? (
              <Link to="/resultadosDos" className="navbarLinks">
                <Button
                  variant="text"
                  color="inherit"
                  className={classes.button}
                >
                  Resultados
                </Button>
              </Link>
            ) : (
              <Link to="/resultados" className="navbarLinks">
                <Button
                  variant="text"
                  color="inherit"
                  className={classes.button}
                >
                  Resultados
                </Button>
              </Link>
            )
          ) : (
            <Button variant="text" color="inherit" className={classes.button}>
              Resultados
            </Button>
          )}
        </Hidden>
        <IconButton aria-label="share" color="inherit">
          <ShareIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

export default Navbar
